import {
    Building2,
    Calendar1,
    ChartArea,
    FileChartColumnIncreasing,
    Logs,
    Mail,
    Newspaper,
    NotebookPen,
    Settings,
    Star,
} from 'lucide-react'
import GridViewIcon from '@mui/icons-material/GridView'

const menuSection = [
    {
        href: '/overview',
        icon: GridViewIcon,
        title: 'Overview',
        titleI18n: 'site.nav.overview',
    },
    {
        href: '/news',
        icon: Newspaper,
        title: 'News',
        titleI18n: 'site.nav.news',
    },
    {
        href: '/calendar',
        icon: Calendar1,
        title: 'Calendar',
        titleI18n: 'site.nav.calendar',
    },
    {
        href: '/issues',
        icon: Logs,
        title: 'Issues',
        titleI18n: 'site.nav.issues',
    },
    {
        href: '/statistics',
        icon: ChartArea,
        title: 'Statistics',
        titleI18n: 'site.nav.statistics',
    },
    {
        href: '/warrants',
        icon: FileChartColumnIncreasing,
        title: 'Warrants',
        titleI18n: 'site.nav.warrants',
    },
    {
        href: '/companies',
        icon: Building2,
        title: 'Companies',
        titleI18n: 'site.nav.companies',
    },
    // {
    //     href: '/investors',
    //     icon: Users,
    //     title: 'Investerare',
    // },
    // {
    //     href: '/advisors',
    //     icon: Briefcase,
    //     title: 'Advisors',
    //     titleI18n: 'site.nav.advisors',
    //     disabled: true,
    // },
    // {
    //     href: '/reports',
    //     icon: Grid,
    //     title: 'Reports',
    //     titleI18n: 'site.nav.reports',
    // },
]

const settingsSection = [
    {
        href: '/profile',
        icon: Settings,
        title: 'Inställningar',
        titleI18n: 'site.nav.settingsSection',
    },
    {
        href: 'https://financelab.se',
        icon: Mail,
        title: 'Contact',
        titleI18n: 'site.nav.contact',
    },
]

const navItems = [
    {
        title: 'Menu',
        titleI18n: 'site.nav.menuSection',
        pages: menuSection,
    },
    {
        title: 'Mina sidor',
        pages: [
            {
                href: '/watch-lists',
                icon: Star,
                title: 'Bevakningslista',
            },
            {
                href: '/notes',
                icon: NotebookPen,
                title: 'Anteckningar',
            },
        ],
    },
    {
        title: 'Support',
        titleI18n: 'site.nav.support',
        pages: settingsSection,
    },
]

export { navItems }
